<button class="close-button no-style" mat-dialog-close tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
</button>

<mat-dialog-content>
    <div class="lyrics" [innerHtml]="lyrics"></div>
</mat-dialog-content>